var MDB = window.MDB || {};

(function(){
	var _isInitialized;

	function assignDataSource(config, selector){
		var dataSourceUrl = selector.data('dataSourceUrl');

		if(dataSourceUrl){
			config.dataTextField = 'Text';
			config.dataValueField = 'Value';

			config.dataSource = new kendo.data.DataSource({
				transport: {
					read: {
						url: dataSourceUrl
					}
				}
			});
		}
		var value = selector.data('value');

		if(value) {
			config.value = value;
		}

		return config;
	}
	
	$.extend(MDB, {
		initKendoDropdownLists: function (selector) {
			selector = $(selector);
			selector.find('[data-type="dropdown"]').each(function () {
		    	
		    	var me = $(this);

		    	if(!me.data('kendoDropDownList')) {
		    		var config = getConfig(me);
					
					me.addClass('dnx-dropdown');
					me.kendoDropDownList(config);
		    	}
			});
		},
		bootKendoDropdownLists: function () {
			if(_isInitialized) {
				return;
			}
			
			_isInitialized = true;
			MDB.initKendoDropdownLists($('body'));
		}
	});

	function getConfig(selector) {
    	var config = selector.data('config');
    	
    	config = config ? config : {};
    	config.autoClose = false;

		return assignDataSource(config, selector);
	}

	$(document).ready(function() {
	   MDB.bootKendoDropdownLists();
	});
}())